module.exports = __webpack_public_path__ + "static/media/matrix.2b2daf53.svg";